export default __webpack_public_path__ + "static/media/u_upload.bb47122d.svg";